<div #bmarkEntry class="order-entry__screen-order__body oe-bmark-entry">
  <!-- CLIENT -->
  <div #panelClient class="order-entry__panel-client-details__container">
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-client"
        #inputClient
        mode="client"
        [disabled]="data.client.disabled"
        [constraint]="data.account.value"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.client.value"
        (ngModelChange)="onClientChange($event)"
        [externalState]="data.client.externalState"
        (onClientSelect)="onClientSelect($event)"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-account"
        #inputAccount
        mode="account"
        [disabled]="data.account.disabled"
        [constraint]="data.client.value"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.account.value"
        (ngModelChange)="onAccountChange($event)"
        [externalState]="data.account.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
        [allowEmpty]="allocationGrid?.hasAllocations"
        (onDatasetChange)="onAccountDatasetChange($event)"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>

    <div class="order-entry__panel-order-details__row">
      <bfx-contacts-input
        [ngClass]="{
          'order-entry__panel-client-details__data-contacts': true,
          'order-entry__panel-client-details__data-contacts--full-size': !data.clientTrader.enabled
        }"
        #inputContacts
        [client]="data.client.value"
        [label]="data.contacts.label"
        [disabled]="data.clientTrader.disabled"
        [selectedTrader]="data.clientTrader.value"
        [(ngModel)]="data.contacts.value"
        (contactChanged)="onContactsChange($event)"
        [externalState]="data.contacts.externalState"
        (traderChanged)="onClientTraderUpdate($event)"
        (commentsChanged)="onClientDefaultCommentsChanged($event)"
        (contactManagerOpen)="onContactManagerOpen($event)"
        (contactManagerClosed)="onContactManagerClosed($event)"
        [fieldsGroup]="true"
      >
      </bfx-contacts-input>
    </div>
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        *ngIf="data.clientTrader.enabled"
        class="order-entry__panel-client-details__client-trader"
        #inputClientTrader
        mode="client_trader"
        [label]="data.clientTrader.label"
        [disabled]="data.clientTrader.disabled"
        [constraint]="data.client.value"
        [(ngModel)]="data.clientTrader.value"
        (ngModelChange)="onClientTraderChange($event)"
        [externalState]="data.clientTrader.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>
    <!-- OBO *ngIf="oboEnabled" -->
    <div *ngIf="false" class="order-entry__panel-obo__container">
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboClient
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboClient.value"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          [inputLabelText]="'OBO Client'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOClient($event)"
        ></bfx-text-input>
      </div>
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboAccount
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboAccount.value"
          [inputLabelText]="'OBO Account'"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOAccount($event)"
        ></bfx-text-input>
      </div>
    </div>
    <!-- TABS -->
    <p-tabView
      #tabs
      class="order-entry__screen-order__tab-view"
      styleClass="bfx-tabview"
      [activeIndex]="tabIndex"
      (onChange)="onTabActivate($event)"
    >
      <p-tabPanel
        class="order-entry__panel-financials__tab-panel"
        [header]="tabData.financials.label"
      >
        <!-- FINANCIALS -->
        <div #panelFinancials class="order-entry__panel-financials__container">
          <div class="order-entry__panel-financials__row">
            <ic-ccy-pair-string
              #inputCcyPair
              class="order-entry__panel-financials__ccy-pair"
              [entryType]="entryType"
              [label]="data.currencyPair.label"
              [dataset]="data.currencyPair.dataset"
              [inverted]="data.currencyPair.inverted"
              [(ngModel)]="data.currencyPair.product"
              (blur)="onCcyPairBlur($event)"
              [externalState]="data.currencyPair.externalState"
            >
            </ic-ccy-pair-string>
            <ic-autocomplete
              #inputOrderType
              class="order-entry__panel-financials__order-type"
              mode="type"
              [label]="data.orderType.label"
              [disabled]="true"
              [dataset]="data.orderType.dataset"
              [(ngModel)]="data.orderType.value"
              [externalState]="data.orderType.externalState"
              [entryType]="entryType"
            >
            </ic-autocomplete>
          </div>

          <div
            class="order-entry__panel-financials__row"
            [style.display]="!control.showIntentAndAmount?'none':'flex'"
          >
            <div class="order-entry__panel-financials__client-intent-container">
              <bfx-client-intent-toggle
                #toggleClientIntent
                class="order-entry__panel-financials__client-intent"
                [label]="data.clientIntent.label"
                [(ngModel)]="data.clientIntent.value"
                (ngModelChange)="onClientIntentToggleChange($event)"
                [externalState]="data.clientIntent.externalState"
              >
              </bfx-client-intent-toggle>
              <ic-fixed-ccy
                #toggleFixedCcy
                class="order-entry__panel-financials__fixed-ccy"
                [ccyPair]="data.fixedCcy.ccyPair"
                [(ngModel)]="data.fixedCcy.value"
                (ngModelChange)="onFixedCcyToggleChange($event)"
              >
              </ic-fixed-ccy>
            </div>
            <bfx-amount-spinner
              #inputOrderAmount
              class="order-entry__panel-financials__order-amount"
              [label]="data.orderAmount.label"
              [currency]="data.fixedCcy.fixedCcy"
              (ngModelChange)="onOrderAmountChange($event)"
              (blur)="onOrderAmountBlur($event)"
              [(ngModel)]="data.orderAmount.value"
              [externalState]="data.orderAmount.externalState"
              *ngIf="isBulking === false"
              [minMaxTouchValid]="true"
              [size]="'sm'"
            >
            </bfx-amount-spinner>
          </div>

          <div class="order-entry__panel-financials__row">
            <bfx-autoComplete
              #inputFixingCode
              class="order-entry__panel-financials__fixing_code"
              nativeDesktopDropdown="fixingCode"
              target="fixingCode"
              delay="5"
              field="code"
              dataKey="code"
              [useAlternateBlur]="true"
              [alternateConfig]="control.fixingCodeAutocompleteConfig"
              [emptyIsInactive]="true"
              [state]="data.fixing.fixingCodeState"
              [disabled]="data.fixing.locked ? true : data.fixing.codeDisabled"
              [suggestions]="data.fixing.fixingCodes"
              [dropdown]="true"
              [label]="data.fixing.fixingCodeLabel"
              [minLength]="0"
              [maxlength]="50"
              [appendTo]="'body'"
              [(ngModel)]="data.fixing.fixingCode"
              (completeMethod)="searchFixingCodes($event)"
              (onSelect)="onSelectFixingCode($event)"
              (onBlur)="onBlurFixingCode($event)"
              [size]="'sm'"
            >
            </bfx-autoComplete>
            <div class="order-entry__panel-financials__fixing_container">
              <bfx-autoComplete
                #inputFixing
                class="order-entry__panel-financials__fixing"
                nativeDesktopDropdown="fixing"
                target="fixing"
                delay="5"
                field="label"
                dataKey="label"
                [useAlternateBlur]="true"
                [alternateConfig]="control.fixingTimeAutocompleteConfig"
                [emptyIsInactive]="true"
                [state]="data.fixing.fixingState"
                [disabled]="data.fixing.locked ? true : data.fixing.disabled"
                [suggestions]="data.fixing.fixings"
                [dropdown]="true"
                [label]="data.fixing.fixingLabel"
                [minLength]="0"
                [maxlength]="50"
                [appendTo]="'body'"
                [convertedUTCTimeFixingList]="convertedUTCTimeFixingList"
                [(ngModel)]="data.fixing.fixing"
                (completeMethod)="searchFixings($event)"
                (ngModelChange)="onFixingChange($event, true)"
                [size]="'sm'"
              >
              </bfx-autoComplete>
              <bfx-calendar
                #fixingDate
                appendTo="body"
                class="order-entry__panel-financials__fixing-date"
                panelStyleClass="bfx-calendar__dropdown__container"
                nativeDesktopCalendar="fixingDateCalendar"
                target="fixingDateCalendar"
                dateFormat="DD-MMM-YYYY"
                [updateOnSelect]="true"
                [label]="data.fixingDate.label"
                [state]="data.fixingDate.state"
                [adjustForTimeZone]="true"
                [showDateInput]="true"
                [showIcon]="true"
                [showActionsBar]="false"
                [minDateAdjustment]="0"
                [minDate]="data.fixingDate.minDate"
                [alignToAutocompleteInput]="false"
                [hideOnDateTimeSelect]="true"
                [disabled]="data.fixing.locked||data.fixingDate.disabled"
                [showOnFocus]="false"
                [(ngModel)]="data.fixingDate.value"
                (onSelect)="onFixingDateChange($event)"
                (onBlur)="onFixingDateBlur($event)"
                (onClose)="onFixingDateCalendarClose($event)"
                (dateValueInput)="onFixingDateChange($event)"
              >
              </bfx-calendar>
            </div>
          </div>
        </div>

        <div class="order-entry__panel-financials__row">
          <bfx-value-date
            class="order-entry__panel-financials__value-date"
            #inputValueDate
            [ngClass]="inputValueDate.classes"
            [label]="data.valueDate.label"
            [entryType]="entryType"
            scrollHeight="120px"
            [disabled]="data.valueDate.disabled"
            [(ngModel)]="data.valueDate.value"
            [(dataset)]="data.valueDate.dataset"
            (ngModelChange)="onValueDateChange($event)"
            [externalState]="data.valueDate.externalState"
            *ngIf="isBulking === false"
          >
          </bfx-value-date>
          <bfx-markup
            #inputMarkup
            class="order-entry__panel-financials__data-markup"
            [label]="data.markup.label"
            [pair]="data.currencyPair.model"
            [isInvert]="data.currencyPair.inverted"
            [markupCriteria]="data.markup.criteria"
            [style.display]="data.markup.config.markupEnabled ? 'flex': 'hidden'"
            [disabled]="data.markup.disabled || !data.markup.config.markupEntry"
            [retrieveEnabled]="data.markup.retrieveEnabled"
            [isAmendMarkup]="data.markup.isAmendMarkup"
            (ngModelChange)="onMarkupChange($event)"
            (onGetMarkupCriteria)="onGetMarkupCriteria($event)"
            (onMarkupCheckboxState)="onMarkupCheckboxState($event)"
            [(ngModel)]="data.markup.value"
            [(trackingRate)]="data.trackingRate.textValue"
            [externalState]="data.markup.externalState"
            [entryType]="entryType"
          >
          </bfx-markup>
        </div>

        <div class="order-entry__panel-financials__row">
          <oe-panel-bmark-allocation-grid
            #allocationGrid
            [currencyPair]="data.currencyPair"
            [valueDate]="data.valueDate"
            [fixingDate]="data.fixingDate"
            [account]="data.account"
            [orderAmount]="data.orderAmount"
            [clientIntent]="data.clientIntent"
            [fixedCcy]="data.fixedCcy"
            [calendar]="data.valueDate.dataset"
            (allocations)="onAllocationsChange($event)"
            (farAllocations)="onFarAllocationsChange($event)"
            (product)="onProductChange($event)"
            (fixedAmount)="onBulkOrderAmountChange($event)"
            (fixedCcy)="onBulkFixedCcyChange($event)"
            (orderIntent)="onBulkOrderIntentChange($event)"
            (swapFixedAmount)="onSwapFixedAmountChange($event)"
            (valueDate)="onBulkValueDateChange($event)"
            (swapTenor)="onSwapTenorChange($event)"
            (swapValueDate)="onSwapValueDateChange($event)"
            (accountCode)="onBulkAccountChange($event)"
          ></oe-panel-bmark-allocation-grid>
        </div>
        <hr class="oe__panel__hr" />
        <div class="order-entry__panel-financials__row">
          <!-- HOLD STP -->
          <ic-hold-stp
            class="order-entry__panel-more__cell"
            #inputHoldSTP
            [label]="data.holdSTP.label"
            [config]="data.holdSTP.enabledConfig"
            [loading]="control.isLoading"
            [client]="data.client.value"
            [account]="data.account.value"
            [(ngModel)]="data.holdSTP.value"
            (ngModelChange)="onHoldSTPChange()"
          >
          </ic-hold-stp>
          <!-- TRADER GROUP -->
          <bfx-autoComplete
            #inputTraderGroup
            class="order-entry__panel-financials__trader-group"
            nativeDesktopDropdown="traderGroup"
            target="traderGroup"
            delay="5"
            field="groupCode"
            dataKey="groupId"
            [useAlternateBlur]="true"
            [alternateConfig]="control.traderGroupAutocompleteConfig"
            [emptyIsInactive]="true"
            [state]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked ? 3 : data.traderGroup.state"
            [disabled]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked"
            [suggestions]="data.traderGroup.traderGroups"
            [dropdown]="true"
            [label]="data.traderGroup.label"
            [minLength]="0"
            [maxlength]="50"
            [appendTo]="'body'"
            [(ngModel)]="data.traderGroup.value"
            (completeMethod)="searchTraderGroup($event)"
            (onFocus)="traderGroupFocus()"
            (onSelect)="onSelectTraderGroup($event)"
            (onBlur)="onSelectTraderGroup($event)"
            [size]="'sm'"
          >
          </bfx-autoComplete>
        </div>
      </p-tabPanel>

      <p-tabPanel [header]="tabData.more.label" class="order-entry__panel-financials__more-panel">
        <!-- MORE -->
        <div class="order-entry__panel-more__container">
          <!-- PANE UNO -->
          <div class="order-entry__panel-more__comments-client__container">
            <div class="order-entry__panel-more__comments-client__row">
              <p-checkbox
                *ngIf="data.commentClient.checkbox.show"
                [bfxInputLabelOnClick]="commentClientLabel"
                [ngClass]="{
                    'bfx-checkbox-enable-control': true,
                    'order-entry__panel-more__comments-client__checkbox': true,
                    'order-entry__panel-more__comments-client__checkbox--checked': data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--unchecked': !data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--locked': data.commentClient.locked
                  }"
                binary="true"
                [(ngModel)]="data.commentClient.checkbox.value"
                [disabled]="data.commentClient.locked"
                (ngModelChange)="onCommentClientCheckboxChange()"
              ></p-checkbox>
              <div
                [ngClass]="{
                  'bfx-input-label': true,
                  'bfx-input-label-sm-bold': true,
                  'bfx-input-label-invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                  'bfx-input-label-disabled':data.commentClient.locked || this.data.commentClient.externalState == 1,
                  'bfx-input-label-enabled': !(data.commentClient.locked || this.data.commentClient.externalState == 1),
              }"
                #commentClientLabel
              >
                {{data.commentClient.label}}
              </div>
            </div>
            <div class="order-entry__panel-more__comments-client__row">
              <textarea
                [rows]="hasCustomFields?2:4"
                pInputTextarea
                #inputCommentClient
                [ngClass]="{
                  'order-entry__panel-more__comments__textarea': true,
                  'order-entry__panel-more__comments-client__input': true,
                  'order-entry__panel-more__comments-client__input--invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                  'order-entry__panel-more__comments-client__input--active': (data.commentClient.checkbox.show && data.commentClient.checkbox.value && !data.commentClient.locked) || (!data.commentClient.checkbox.show && !data.commentClient.locked),
                  'order-entry__panel-more__comments-client__input--inactive': !(this.data.commentClient.externalState == 1 && !data.commentClient.locked) && (data.commentClient.checkbox.show && !data.commentClient.checkbox.value || data.commentClient.locked) || (!data.commentClient.checkbox.show && data.commentClient.locked)
                }"
                [(ngModel)]="data.commentClient.value"
                (ngModelChange)="onContactManagerClosed($event)"
                [maxlength]="control.commentSize"
                [disabled]="data.commentClient.locked || (data.commentClient.checkbox.show && !data.commentClient.checkbox.value)"
                (onFocus)="$event.target.select()"
                (blur)="onCommentClientChange();"
              ></textarea>
            </div>
          </div>
          <bfx-comment-warning></bfx-comment-warning>
          <!-- PRIVATE COMMENT -->
          <div
            *ngIf="data.commentPrivate.show"
            class="order-entry__panel-more__comments-private__container"
          >
            <div class="order-entry__panel-more__comments-private__row">
              <div
                [ngClass]="{
                  'bfx-input-label': true,
                  'bfx-input-label-sm-bold': true,
                  'bfx-input-label-disabled':data.commentPrivate.locked,
                  'bfx-input-label-enabled': !(data.commentPrivate.locked),
              }"
                class="order-entry__panel-more__comments-private__label"
              >
                {{data.commentPrivate.label}}
              </div>
            </div>
            <div class="order-entry__panel-more__comments-private__row">
              <textarea
                [rows]="hasCustomFields?2:4"
                pInputTextarea
                [ngClass]="{
                'order-entry__panel-more__comments__textarea': true,
                'order-entry__panel-more__comments-private__input': true,
                'order-entry__panel-more__comments-private__input--active': !data.commentPrivate.locked,
                'order-entry__panel-more__comments-private__input--inactive': data.commentPrivate.locked
              }"
                [(ngModel)]="data.commentPrivate.value"
                (ngModelChange)="onContactManagerClosed($event)"
                [maxlength]="control.commentSize"
                [disabled]="data.commentPrivate.locked"
                (focus)="$event.target.select()"
                (blur)="onCommentPrivateChange();"
              ></textarea>
            </div>
          </div>
          <bfx-comment-warning *ngIf="data.commentPrivate.show"></bfx-comment-warning>
        </div>
        <hr class="oe__panel__hr" />
        <!-- PANE DUE -->
        <div class="order-entry__panel-more__extras">
          <div class="order-entry__panel-more__row">
            <ic-auto-fwd-pricing
              class="order-entry__panel-more__cell"
              #autoFwdPricing
              [enabledConfig]="data.autoFwdPricing.enabledConfig"
              [manualOnly]="data.autoFwdPricing.manualOnly"
              [isLoading]="control.isLoading"
              [clientId]="null == data.client.value ? null : data.client.value.clientId"
              [clientAutoFwdType]="null == data.client.value ? null : data.client.value.bmForwardPricing"
              [valueDate]="data.valueDate.value"
              [product]="null == data.product ? null : data.product.value"
              [label]="data.autoFwdPricing.label"
              [(ngModel)]="data.autoFwdPricing.value"
              (ngModelChange)="onAutoFwdPricingChange()"
            >
            </ic-auto-fwd-pricing>
          </div>
          <div class="order-entry__panel-more__row">
            <!-- PRIVATE ORDER -->
            <ic-private-order
              class="order-entry__panel-more__cell"
              [ngStyle]="{
                'visibility': data.privateOrder.show  ? 'visible': 'hidden'
              }"
              #inputPrivateOrder
              [loading]="control.isLoading"
              [label]="data.privateOrder.label"
              [(ngModel)]="data.privateOrder.value"
              (ngModelChange)="onPrivateOrderChange()"
            >
            </ic-private-order>
          </div>
        </div>
        <hr class="oe__panel__hr" />
        <!-- MORE Custom Fields -->
        <div *ngIf="hasCustomFields" class="order-entry__panel-more__custom-fields">
          <div class="order-entry__panel-more__custom-fields__container">
            <ic-custom-fields
              #customFieldComponent
              [operationMode]="operationMode"
              (valuesChanged)="onCustomValuesChange($event)"
              [externalState]="data.customValues.externalState"
            ></ic-custom-fields>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
